// import { configureStore } from "@reduxjs/toolkit";
// import hotelApproveReducer from "./slices/admin/hotel-approve-slice";
// import experienceAdminReducer from "./slices/admin/experience-admin-slice";
// import sliderReducer from "./slices/slider-slice";
// import hotelSearchReducer from "./slices/customer/hotel-search-slice";
// import bookingReducer from "./slices/customer/customer-booking-slice";
// import hotelRateSettingsReducer from "./slices/hotel-rate-settings-slice";
// import amenityReducer from "./slices/amenity-slice";
// import invoiceReducer from "./slices/invoice-slice";

// export const store = configureStore({
//   reducer: {
//     hotelApprove: hotelApproveReducer,
//     experienceAdmin: experienceAdminReducer,
//     slider: sliderReducer,
//     hotelSearch: hotelSearchReducer,
//     booking: bookingReducer,
//     hotelRateSettings: hotelRateSettingsReducer,
//     amenity: amenityReducer,
//     invoice: invoiceReducer,
//   },
// });

// export type RootState = ReturnType<typeof store.getState>;
// export type AppDispatch = typeof store.dispatch;
import { configureStore } from "@reduxjs/toolkit";
import hotelApproveReducer from "./slices/admin/hotel-approve-slice";
import experienceAdminReducer from "./slices/admin/experience-admin-slice";
import sliderReducer from "./slices/slider-slice";
import hotelSearchReducer from "./slices/customer/hotel-search-slice";
import bookingReducer from "./slices/customer/customer-booking-slice";
import hotelRateSettingsReducer from "./slices/hotel-rate-settings-slice";
import amenityReducer from "./slices/amenity-slice";
import invoiceReducer from "./slices/invoice-slice";
import newsReducer from "./slices/admin/news-slice";

// New admin slices
import adminBookingReducer from "./slices/admin/booking-slice";
import customerReducer from "./slices/admin/customer-slice";
import partnerReducer from "./slices/admin/partner-slice";
import newsletterReducer from "./slices/admin/newsletter-slice";
import contactMessageReducer from "./slices/admin/contact-message-slice";
import currencyRatesReducer from "./slices/admin/currencyRatesSlice";
import tourGuideReducer from "./slices/admin/tour-guide-slice";

//experience
import experienceReducer from "./slices/admin/experience-slice";

//transport
import transportApproveReducer from "@/redux/slices/admin/transport-approve-slice";
import transportBookingsReducer from "@/redux/slices/admin/transport-bookings-slice";
import transportCustomRequestsReducer from "@/redux/slices/admin/transport-custom-requests-slice";
import transportPaymentsReducer from "@/redux/slices/admin/transport-payments-slice";

export const store = configureStore({
  reducer: {
    // Existing
    hotelApprove: hotelApproveReducer,
    experienceAdmin: experienceAdminReducer,
    slider: sliderReducer,
    hotelSearch: hotelSearchReducer,
    booking: bookingReducer,
    hotelRateSettings: hotelRateSettingsReducer,
    amenity: amenityReducer,
    invoice: invoiceReducer,

    // New admin sections
    adminBookings: adminBookingReducer,
    customers: customerReducer,
    partners: partnerReducer,
    newsletters: newsletterReducer,
    contactMessages: contactMessageReducer,
    currencyRates: currencyRatesReducer,
    news: newsReducer,
    tourGuides: tourGuideReducer,

    //experience
    experiences: experienceReducer,

    //transport
    transportApprove: transportApproveReducer,
    transportBookings: transportBookingsReducer,
    transportCustomRequests: transportCustomRequestsReducer,
    transportPayments: transportPaymentsReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;